import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FiPlus, FiTrash2 } from "react-icons/fi";

export default function EditBudgetModal({ show, onHide }) {
  const [revenues, setRevenues] = useState([
    { title: "Office Supplies", amount: 250000 }
  ]);

  const [expenses, setExpenses] = useState([
    { title: "", amount: "" }
  ]);

  const [tax, setTax] = useState("");

  // ✅ Calculations
  const totalRevenue = revenues.reduce(
    (sum, r) => sum + Number(r.amount || 0),
    0
  );

  const totalExpense = expenses.reduce(
    (sum, e) => sum + Number(e.amount || 0),
    0
  );

  const profit = totalRevenue - totalExpense;
  const budget = profit - Number(tax || 0);

  // ➕ Add
  const addRevenue = () =>
    setRevenues([...revenues, { title: "", amount: "" }]);

  const addExpense = () =>
    setExpenses([...expenses, { title: "", amount: "" }]);

  // ❌ Delete
  const removeRevenue = (i) =>
    setRevenues(revenues.filter((_, index) => index !== i));

  const removeExpense = (i) =>
    setExpenses(expenses.filter((_, index) => index !== i));

  return (
    <Modal show={show} onHide={onHide} centered className="budget-modal">
      <Modal.Header closeButton>
        <Modal.Title>Edit Budget</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>

          {/* Budget Title */}
          <Form.Group className="mb-3">
            <Form.Label>Budget Title</Form.Label>
            <Form.Control defaultValue="Office Supplies" />
          </Form.Group>

          {/* Type */}
          <Form.Group className="mb-3">
            <Form.Label>Choose Budget respect type</Form.Label>
            <div className="d-flex gap-3">
              <Form.Check type="radio" label="Project" name="type" />
              <Form.Check type="radio" label="Category" name="type" defaultChecked />
            </div>
          </Form.Group>

          {/* Dates */}
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Start Date</Form.Label>
                <Form.Control placeholder="dd/mm/yyyy" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>End Date</Form.Label>
                <Form.Control placeholder="dd/mm/yyyy" />
              </Form.Group>
            </Col>
          </Row>

          {/* ================= REVENUE ================= */}
          <h6 className="section-title">Expected Revenues</h6>

          {/* Header Row */}
          <Row className="mb-2 d-none d-md-flex">
            <Col md={5}><small className="text-muted">Revenue Title</small></Col>
            <Col md={5}><small className="text-muted">Revenue Amount</small></Col>
            <Col md={2}></Col>
          </Row>

          {revenues.map((item, i) => (
            <Row key={i} className="align-items-center mb-2">
              
              <Col md={5}>
                <Form.Control
                  placeholder="Revenue Title"
                  value={item.title}
                  onChange={(e) => {
                    const data = [...revenues];
                    data[i].title = e.target.value;
                    setRevenues(data);
                  }}
                />
              </Col>

              <Col md={5}>
                <Form.Control
                  placeholder="Amount"
                  value={item.amount}
                  onChange={(e) => {
                    const data = [...revenues];
                    data[i].amount = e.target.value;
                    setRevenues(data);
                  }}
                />
              </Col>

              <Col md={2} className="d-flex gap-2 mt-2 mt-md-0">

                {/* ONLY FIRST ROW */}
                {i === 0 && (
                  <Button className="icon-btn" onClick={addRevenue}>
                    <FiPlus />
                  </Button>
                )}

                {/* DELETE */}
                {i !== 0 && (
                  <Button className="icon-btn delete" onClick={() => removeRevenue(i)}>
                    <FiTrash2 />
                  </Button>
                )}

              </Col>
            </Row>
          ))}

          <Form.Group className="mb-3">
            <Form.Label>Overall Revenue (A)</Form.Label>
            <Form.Control value={totalRevenue} readOnly />
          </Form.Group>

          {/* ================= EXPENSE ================= */}
          <h6 className="section-title">Expected Expenses</h6>

          {/* Header */}
          <Row className="mb-2 d-none d-md-flex">
            <Col md={5}><small className="text-muted">Expenses Title</small></Col>
            <Col md={5}><small className="text-muted">Expenses Amount</small></Col>
            <Col md={2}></Col>
          </Row>

          {expenses.map((item, i) => (
            <Row key={i} className="align-items-center mb-2">

              <Col md={5}>
                <Form.Control
                  placeholder="Expenses Title"
                  value={item.title}
                  onChange={(e) => {
                    const data = [...expenses];
                    data[i].title = e.target.value;
                    setExpenses(data);
                  }}
                />
              </Col>

              <Col md={5}>
                <Form.Control
                  placeholder="Amount"
                  value={item.amount}
                  onChange={(e) => {
                    const data = [...expenses];
                    data[i].amount = e.target.value;
                    setExpenses(data);
                  }}
                />
              </Col>

              <Col md={2} className="d-flex gap-2 mt-2 mt-md-0">

                {i === 0 && (
                  <Button className="icon-btn" onClick={addExpense}>
                    <FiPlus />
                  </Button>
                )}

                {i !== 0 && (
                  <Button className="icon-btn delete" onClick={() => removeExpense(i)}>
                    <FiTrash2 />
                  </Button>
                )}

              </Col>
            </Row>
          ))}

          <Form.Group className="mb-3">
            <Form.Label>Overall Expense (B)</Form.Label>
            <Form.Control value={totalExpense} readOnly />
          </Form.Group>

          {/* Profit + Tax */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Expected Profit (C=A-B)</Form.Label>
                <Form.Control value={profit} readOnly />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Tax (D)</Form.Label>
                <Form.Control
                  value={tax}
                  onChange={(e) => setTax(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mt-3">
            <Form.Label>Budget Amount (E=C-D)</Form.Label>
            <Form.Control value={budget} readOnly />
          </Form.Group>

        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button className="save-btn">Save Changes</Button>
      </Modal.Footer>

      {/* 🎨 STYLE */}
      <style>{`
        .section-title {
          font-weight: 600;
          margin-top: 10px;
          margin-bottom: 8px;
        }

        .icon-btn {
          background: #f97316;
          border: none;
          color: white;
          width: 38px;
          height: 38px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
                  .icon-btn:hover {
          background: #f97316;
   
        }

        .icon-btn.delete {
          background: #ef4444;
        }

        
        .icon-btn.delete:hover {
          background: #ef4444;
        }
        .save-btn {
          background: #f97316;
          border: none;
        }
          .save-btn:hover {
          background: #f97316;
        
        }

        @media (max-width: 768px) {
          .section-title {
            font-size: 14px;
          }

          .icon-btn {
            width: 34px;
            height: 34px;
          }
        }
      `}</style>
    </Modal>
  );
}